import logo from "../asset/logo-gold.webp";
import heroimg1 from "../asset/heroimg1.webp";
import heroimg2 from "../asset/heroimg2.webp";
import heroimg3 from "../asset/heroimg3.webp";
import heroimg4 from "../asset/heroimg4.webp";
import heroimg5 from "../asset/heroimg5.webp";
import homeourlocation1 from "../asset/home-our-location-1.webp";
import homeourlocation2 from "../asset/home-our-location-2.webp";
import homeourlocation3 from "../asset/home-our-location3.webp";
import homeaboutus from "../asset/home-about-us.webp";
// import goldline from "../asset/gold-line.png";
import homeourbrand from "../asset/home-our-brands2.webp";
import homeourbrand2 from "../asset/home-our-brands3.webp";
import homeourbrand3 from "../asset/home-our-brand5.webp";
import homeblogimg1 from "../asset/home-blog-img1.webp";
import homeblogimg2 from "../asset/home-blog-img2.webp";
import homeblogimg3 from "../asset/home-blog-img3.webp";
import homeblogimg4 from "../asset/home-blog-img4.webp";
import homeourlocationbg1 from "../asset/home-our-location-bg-1.webp";
// import homeourlocationbg2 from "../asset/home-our-location2.jpg";
import homeeventimg1 from "../asset/home-event-img1.webp";
import homeeventimg2 from "../asset/home-event-img2.webp";
import homeeventimg3 from "../asset/home-event-img3.webp";
import homeeventimg4 from "../asset/home-event-img4.webp";
import homeeventwedding from "../asset/home-event-wedding.webp";
import homeeventconferenceimg from "../asset/home-event-conference.webp";
import pinesingheadbg from "../asset/pine-sing-head-bg.webp";
import pinewoodabout from "../asset/pinewoodabout.webp";
import pinewoodsingeventfaci from "../asset/pinewood-sing-event-faci.webp";
import keyImg from "../asset/key-img.webp";
import king from "../asset/kinglogo.webp";
import logo05 from "../asset/logo05.webp";

// KK Origbal Images
import prabhuhomeheroo1 from "../asset/prabhu-home-heroo1.webp";
import sasanimg15 from "../asset/sasan-img15.webp";
import prabhuimg12 from "../asset/prabhu-img12.webp";
import prabhuimg9 from "../asset/prabhu-img9.webp";
import sasanimg13 from "../asset/sasan-img13.webp";
import sasanimg12 from "../asset/sasan-img12.webp";
import wed1 from "../asset/wed1.webp";
import wed2 from "../asset/wed2.webp";
import wed9 from "../asset/wed9.webp";
import wed11 from "../asset/wed11.webp";
import wed12 from "../asset/wed12.webp";
import prabhuimg26 from "../asset/prabhu-img26.webp";
import sasanimg11 from "../asset/sasan-img11.webp";
import sasanimg14 from "../asset/sasan-img14.webp";
import stayinnimg4 from "../asset/stayinn-img4.webp";
import wed3 from "../asset/wed3.webp";
import wed8 from "../asset/wed8.webp";
import prabhuimg16 from "../asset/prabhu-img16.webp";
import prabhuimg18 from "../asset/prabhu-img18.webp";
import prabhuimg4 from "../asset/prabhu-img4.webp";
import prabhuimg14 from "../asset/prabhu-img14.webp";
import prabhuimg2 from "../asset/prabhu-img2.webp";
import kinglogoup from "../asset/logo03.webp";
import chessking from "../asset/00-Chess-King.webp";
import keyimg from "../asset/keylogo.webp";
import keylogo1 from "../asset/key_sec_logo1.webp";
import keylogo2 from "../asset/key_logo_2.webp";
import keylogo3 from "../asset/key_logo_3.webp";
import kk1 from "../asset/kk1.webp";
import kk3 from "../asset/kk3.jpg";
// import kk4 from "../asset/kk4.jpg";
import kk6 from "../asset/kk6.webp";
import kk7 from "../asset/kk7.webp";
import kk8 from "../asset/kk8.webp";
import kk9 from "../asset/kk9.webp";
import kk10 from "../asset/kk10.webp";
import kkr1 from "../asset/kkr2.webp";
import kkr2 from "../asset/kkr3.webp";
import qrcode from "../asset/King'sKraft Brochure .png"

export default {
  logo,
  heroimg1,
  heroimg2,
  heroimg3,
  heroimg4,
  heroimg5,
  homeourlocation1,
  homeourlocation2,
  homeourlocation3,
  homeaboutus,
  // goldline,
  homeourbrand,
  homeourbrand2,
  homeourbrand3,
  homeblogimg1,
  homeblogimg2,
  homeblogimg3,
  homeblogimg4,
  homeourlocationbg1,
  homeeventimg1,
  homeeventimg2,
  homeeventimg3,
  homeeventimg4,
  homeeventwedding,
  homeeventconferenceimg,
  pinesingheadbg,
  pinewoodabout,
  pinewoodsingeventfaci,
  keyImg,
  king,
  logo05,
  prabhuhomeheroo1,
  sasanimg15,
  prabhuimg12,
  prabhuimg9,
  sasanimg12,
  sasanimg13,
  wed1,
  wed2,
  wed9,
  wed11,
  wed12,
  prabhuimg26,
  sasanimg11,
  sasanimg14,
  stayinnimg4,
  wed3,
  wed8,
  prabhuimg16,
  prabhuimg18,
  prabhuimg4,
  prabhuimg14,
  prabhuimg2,
  kinglogoup,
  chessking,
  keyimg,
  keylogo1,
  keylogo2,
  keylogo3,
  kk1,
  kk3,
  kk6,
  kk7,
  kk8,
  kk9,
  kk10,
  kkr1,
  kkr2,
  qrcode,
};
